var map = {
	"./a_bite_to_eat_1.jpg": 882,
	"./a_bite_to_eat_2.jpg": 869,
	"./four_seasons_1.jpg": 948,
	"./four_seasons_2.jpg": 467,
	"./four_seasons_3.jpg": 630,
	"./four_seasons_4.jpg": 693,
	"./garden_rose_1.jpg": 244,
	"./garden_rose_2.jpg": 848,
	"./garden_rose_3.jpg": 54,
	"./garden_rose_4.jpg": 397,
	"./morning_treat_1.jpg": 349,
	"./morning_treat_2.jpg": 69,
	"./morning_treat_3.jpg": 808,
	"./red_onion_1.jpg": 480,
	"./red_onion_2.jpg": 407,
	"./red_onion_3.jpg": 402,
	"./summer_strawberries_1.jpg": 594,
	"./summer_strawberries_2.jpg": 797,
	"./summer_strawberries_3.jpg": 832,
	"./sweet_nectarine_1.jpg": 925,
	"./sweet_nectarine_2.jpg": 674,
	"./sweet_nectarine_3.jpg": 135,
	"./tart_and_crisp_1.jpg": 370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;